import { configs } from './configs';

export const ApiRoutes = {
  locations: 'locations',
  services: 'services',
  search: 'search',
  seatDetails: 'trip/{{trip_id}}/seats',
  estimateTrip: 'estimate',
  nationality: 'nationality',
  checkout: 'checkout',
  histories: 'histories',
  historiesUpcoming: 'upcoming/trip',
  historyDetails: 'history',
  tripDetail: 'trip',
  cancelPolicy: 'cancel/policy',
  rating: 'operator/{{operator_id}}/rating',
  tripGallery: 'trip/{{trip_id}}/galleries',
  paymentList: `${configs.v3BaseURL}payment-gateways/list?type=travel`,
  cardList: `${configs.v3BaseURL}user/me/cards?type=travel`,
  bannerList: `${configs.v3BaseURL}customer/banner/list?filter[position]=bus-front-top`,
  // bannerList: `${configs.v3BaseURL}customer/banner/list?filter[position]=front-top`,
  rateReservation: 'rating',
  searchCoupon: 'coupon',
  checkSeats: 'trip/{{trip_id}}/seats/check',
  // SOCKET REALTIME
  getSession: 'auth/session',
  refreshSession: 'auth/session/resume',
  selectSeat: 'selection/selecting',
  viewSelectedSeat: 'selection/view',
  unselectSeat: 'selection/unselect',
  cancelChceckout: 'cancel/pending/booking',
};
